import { createApp, ref } from 'vue'
import App from './App.vue'
import axios from 'axios'

import { router } from './router'
import './permission'
import {
    ElSelect,
    ElInput,
    ElButton,
    ElTable,
    ElTableColumn,
    ElForm,
    ElMessage,
    ElMessageBox,
    ElDialog,
    ElTimePicker,
    ElContainer,
    ElHeader,
    ElMenu,
    ElCard,
    ElIcon,
    ElProgress,
    ElDropdown,
    ElDropdownMenu,
    ElDropdownItem,
    ElTag,
    ElSlider,
    ElPopover,
    ElColorPicker,
    ElInputNumber,
    ElMenuItemGroup,
    ElStep,
    ElSteps,
    ElSwitch,
    ElDatePicker,
    ElAutocomplete,
    ElDrawer,
    ElSkeleton,
    ElCarousel,
    ElCarouselItem,
    ElTabs,
    ElTabPane,
    ElRadioGroup,
    ElRadio,
    ElCheckboxGroup,
    ElCheckbox,
    ElPagination
} from 'element-plus'
import  ElementPlus  from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'


import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'

import '@vue-flow/core/dist/theme-default.css';
import '@vue-flow/core/dist/style.css'
// import {VueFlow } from '@vue-flow/core'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'amfe-flexible'
import drag from "v-drag"
// let messageNum = 0;
// const createMessage = () => {
    // if (messageNum === 0) {
    //     messageNum = 1
    //     ElMessageBox.confirm("登录状态已失效，请重新登录", "确认登出", {
    //             confirmButtonText: "重新登录",
    //             cancelButtonText: "取消",
    //             type: "warning",
    //         })
    //         .then(() => {
    //             router.push(`/login`);
    //             localStorage.setItem("token", "");
    //             localStorage.setItem("username", "");
    //             localStorage.setItem("logintime", 0);
    //             //console.log(location)
    //             messageNum = 0
    //             location.reload();
    //         })
    //         .catch(() => { messageNum = 0 });
    // }
// };
axios.defaults.BaseURL = '';
axios.interceptors.request.use(
    config => {
        let token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = 'core ' + token;
        }
        return config;
    }, error => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.log(error)
            // if (error.response.status == 500) {
            //     ElMessage({ type: "error", message: error.response.data, offset: window.screen.height / 2, showClose: true })
            // }
        if (error.response && error.response.status === 401) {
            createMessage()
        }
        return Promise.reject(error)
    }
)
const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router);
app.use(ElSelect);
app.use(ElInput);
app.use(ElButton);
app.use(ElTable);
app.use(ElTableColumn);
app.use(ElForm);
app.use(ElDialog);
app.use(ElTimePicker);
app.use(ElMessage);
app.use(ElContainer);
app.use(ElHeader);
app.use(ElMenu);
app.use(ElCard);
app.use(ElIcon);
app.use(ElProgress);
app.use(ElDropdown);
app.use(ElDropdownMenu);
app.use(ElDropdownItem);
app.use(ElTag);
app.use(ElSlider);
app.use(ElColorPicker);
app.use(ElPopover);
app.use(ElInput);
app.use(ElInputNumber);
app.use(ElMenuItemGroup)
app.use(ElStep)
app.use(ElSteps)
app.use(ElSwitch)
app.use(ElDatePicker)
app.use(ElAutocomplete)
app.use(ElDrawer)
app.use(ElSkeleton)
app.use(ElCarousel)
app.use(ElCarouselItem)
app.use(ElTabs, ElTabPane)
app.use(ElRadioGroup)
app.use(ElRadio)
app.use(ElCheckboxGroup)
app.use(ElCheckbox)
app.use(ElPagination)
app.use(drag, {});
app.use(ElementPlus, {
    locale: zhCn,
  })
// app.us(VueFlow);

app.config.globalProperties.$Axios = axios;

// 全局错误处理程序
app.config.errorHandler = (err, vm, info) => {
    console.error('Error:', err);
    console.error('Vue component:', vm);
    console.error('Additional info:', info);
};
// const dataList1=ref([])
app.provide('DATA', ref([]))

app.mount('#app');
// 解决ResizeObserver限制
const debounce = (fn, delay) => {
    let timer = null;
    return function() {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(context, args);
        }, delay);
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}